var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "flex",
    {
      staticClass: "search-image-uploader",
      attrs: { direction: "column", justify: "center", align: "center" },
    },
    [
      _c(
        "flex",
        {
          staticClass: "upload-box",
          attrs: {
            id: "uploadBox",
            direction: "column",
            justify: "center",
            align: "center",
          },
          on: {
            click: _vm.upload,
            dragenter: _vm.handleDragenter,
            dragover: _vm.handleDragover,
            drop: _vm.handleDrop,
          },
        },
        [
          !_vm.uploadImage
            ? _c("span", { staticClass: "upload-text" }, [
                _vm._v("\n      点击上传\n    "),
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.uploadImage
            ? _c("span", { staticClass: "upload-tips" }, [
                _vm._v("\n      拖拽图片到这里\n    "),
              ])
            : _c("img", {
                staticClass: "upload-image",
                attrs: { src: _vm.uploadImage },
              }),
        ]
      ),
      _vm._v(" "),
      _c("input", {
        staticStyle: { display: "none" },
        attrs: { id: "upload", type: "file" },
        on: {
          change: function ($event) {
            return _vm.uploadSearchImage($event, "click")
          },
        },
      }),
      _vm._v(" "),
      _c("flex", { attrs: { justify: "center" } }, [
        _c(
          "span",
          { staticClass: "submit-text", on: { click: _vm.submitSearchUpload } },
          [_vm._v("\n      确认\n    ")]
        ),
        _vm._v(" "),
        _c(
          "span",
          {
            staticClass: "submit-text clear",
            on: { click: _vm.clearSearchImage },
          },
          [_vm._v("\n      清除\n    ")]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }